export enum InsuranceTypes {
  PrivateInsurance = 'Private Insurance',
  Medicare = 'Medicare',
  Medicaid = 'Medicaid',
  NoInsurance = 'No Insurance',
}
